export const CHAT_MESSAGE_THREAD_ID = 'chatMessageThread';
